import { ApiTags, rootApi } from '../../../../services/rootApi';

import { IService } from '../models';

const TAG = ApiTags.Service;
const getTags = (entities: IService[]) => [...entities.map((p) => ({ type: TAG, id: p.id })), TAG]

const servicesApi = rootApi.injectEndpoints({
  overrideExisting: false,
  endpoints: builder => ({
    getService: builder.query<IService, string>({
      query: (serviceId) => `/services/${serviceId}`,
      providesTags: (result) => result ? [{ type: TAG, id: result.id }] : [TAG]
    }),
     
    getContactServices: builder.query<IService[], string>({
      query: (contactId) => {
        return `/services/Contact(${contactId})`;
      },
      providesTags: (result) => result ? getTags(result) : [TAG]
    }),

    getRootServices: builder.query<IService[], { programType?: any, genderType?: any, serviceTypeParam?: any }>({
      query: ({ programType, genderType, serviceTypeParam }) => {
        return `/services/root(${programType})/(${genderType})/serviceType(${serviceTypeParam})`;
      },
      providesTags: (result) => result ? getTags(result) : [TAG]
    }),

    getChildServices: builder.query<IService[], { parentId?: string, programType?: any, genderType?: any, serviceTypeParam?: any }>({
      query: ({ parentId, programType, genderType, serviceTypeParam }) => {
        return `/services/children(${parentId})/(${programType})/(${genderType})/serviceType(${serviceTypeParam})`;
      },
      providesTags: (result) => result ? getTags(result) : [TAG]
    }),
  })
})

export const {
  useGetServiceQuery,
  useLazyGetServiceQuery,
  useGetContactServicesQuery,
  useLazyGetContactServicesQuery,
  useGetChildServicesQuery,
  useLazyGetChildServicesQuery
} = servicesApi;